import { Progress } from '@/components/ui/progress'
import {
  CARD_CLASS,
  EYEBROW_CLASS,
  severityBarClass,
  severityTextClass,
} from './SiteHealthStyles'
import type { SeveritySummaryProps } from './siteHealthComponents.types'

const SEVERITIES = ['critical', 'warning', 'info'] as const

export default function SeveritySummary({ counts }: SeveritySummaryProps) {
  const total = SEVERITIES.reduce((sum, severity) => sum + counts[severity], 0)
  const max = Math.max(...SEVERITIES.map((severity) => counts[severity]), 1)

  return (
    <section className={`${CARD_CLASS} p-6`}>
      <p className={EYEBROW_CLASS}>Findings by severity</p>
      <div className="mt-4 flex items-baseline gap-3">
        <span className="text-6xl font-semibold tabular-nums tracking-tight text-foreground">
          {total}
        </span>
        <span className="text-2xl text-muted-foreground">total</span>
      </div>
      <div className="mt-6 space-y-4">
        {SEVERITIES.map((severity) => {
          const count = counts[severity]

          return (
            <div
              key={severity}
              className="grid grid-cols-[6rem_1fr_3rem] items-center gap-3 text-sm"
            >
              <span
                className={`inline-flex items-center gap-2 capitalize ${severityTextClass(severity)}`}
              >
                <span
                  aria-hidden="true"
                  className={`inline-block size-2 rounded-full ${severityBarClass(severity)}`}
                />
                {severity}
              </span>
              <Progress
                aria-label={`${severity} findings`}
                indicatorClassName={severityBarClass(severity)}
                max={max}
                value={count}
              />
              <span className="text-right tabular-nums text-muted-foreground">
                {count}
              </span>
            </div>
          )
        })}
      </div>
    </section>
  )
}
